/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================
*/

import { createAppTheme } from "assets/theme";

export function createAppThemeRTL(colorMode = "light") {
  return createAppTheme(colorMode, { direction: "rtl" });
}

export default createAppThemeRTL("light");
